import Sounds from '../core/sounds/Sounds';
import DomHelper from '../core/shared/helpers/DomHelper';

document.body.addEventListener('click', function (e) {
  const interactableSelector = 'button, a, input, ._interactable';
  const interactableEl = DomHelper.matches(e.target, interactableSelector) ||
    DomHelper.closest(e.target, interactableSelector);
  if (interactableEl) Sounds.click();
});
